import { FormProvider } from 'react-hook-form';
import { useCreateClientAdminUserForm } from './hooks';
import { CreateClientAdminUserFormPresentation } from './presentations';

export const CreateClientAdminUserForm: React.FC = () => {
  const {
    state: { methods, isSubmitDisabled },
    actions: { handleSubmit },
  } = useCreateClientAdminUserForm();

  return (
    <FormProvider {...methods}>
      <CreateClientAdminUserFormPresentation
        isSubmitDisabled={isSubmitDisabled}
        onSubmit={handleSubmit}
      />
    </FormProvider>
  );
};
